import { Plus, Trash2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { Btn, inputCls } from "@/pages/portal/PortalSteps";

const L = ({ label, children }) => <label className="block"><span className="mb-1.5 block text-[13px] font-semibold text-slate-700">{label}</span>{children}</label>;

function RefRow({ t, r, mat, i, onChange, onRemove }) {
  const id = `${mat}-${i}`;
  return (
    <div className="grid gap-3 rounded-lg bg-slate-50 p-3 sm:grid-cols-2" data-testid={`portal-ds-row-${id}`}>
      <L label={t.ds_type}>
        <select data-testid={`portal-ds-type-${id}`} className={inputCls} value={r.type || "conventional"} onChange={(e) => onChange({ type: e.target.value })}>
          <option value="conventional">{t.ds_conventional}</option><option value="transitional">{t.ds_transitional}</option>
        </select>
      </L>
      <L label={t.ds_reference}><input data-testid={`portal-ds-ref-${id}`} className={cn(inputCls, "font-mono uppercase")} value={r.reference || ""} onChange={(e) => onChange({ reference: e.target.value.toUpperCase() })} /></L>
      <L label={t.ds_verification}><input data-testid={`portal-ds-ver-${id}`} className={cn(inputCls, "font-mono")} value={r.verification || ""} onChange={(e) => onChange({ verification: e.target.value })} /></L>
      <L label={t.ds_placed_on}><input data-testid={`portal-ds-date-${id}`} type="date" className={inputCls} value={r.placed_on || ""} onChange={(e) => onChange({ placed_on: e.target.value })} /></L>
      <button type="button" data-testid={`portal-ds-remove-${id}`} onClick={onRemove} className="flex items-center gap-1.5 justify-self-start text-sm font-medium text-rose-700 hover:underline"><Trash2 className="h-4 w-4" />{t.ds_remove}</button>
    </div>
  );
}

export function DownstreamStep({ t, v, set }) {
  const conf = v.filter((m) => m.confirmed);
  if (!conf.length) return <p className="text-slate-500">{t.no_confirmed}</p>;
  const setRefs = (mat, fn) => set((cur) => cur.map((m) => (m.material === mat ? { ...m, downstream_refs: fn(m.downstream_refs || []) } : m)));
  return (
    <div className="space-y-4" data-testid="portal-downstream-step">
      <p className="rounded-xl border border-sky-200 bg-sky-50 p-4 text-sm text-sky-900" data-testid="portal-ds-intro">{t.ds_intro}</p>
      {conf.map((m) => (
        <div key={m.material} className="space-y-3 rounded-xl border border-slate-200 p-4" data-testid={`portal-ds-${m.material}`}>
          <p className="font-semibold text-slate-900">{m.material} · {m.description}</p>
          {!(m.downstream_refs || []).length && <p className="text-sm text-slate-500">{t.ds_none}</p>}
          {(m.downstream_refs || []).map((r, i) => (
            <RefRow key={i} t={t} r={r} mat={m.material} i={i} onChange={(p) => setRefs(m.material, (rs) => rs.map((x, j) => (j === i ? { ...x, ...p } : x)))} onRemove={() => setRefs(m.material, (rs) => rs.filter((_, j) => j !== i))} />
          ))}
          <Btn variant="outline" data-testid={`portal-ds-add-${m.material}`} onClick={() => setRefs(m.material, (rs) => [...rs, { type: "conventional", reference: "", verification: "", placed_on: "" }])} className="w-full sm:w-auto"><Plus className="h-4 w-4" />{t.ds_add}</Btn>
        </div>
      ))}
    </div>
  );
}
